import { render } from "./PreferredSkills.vue?vue&type=template&id=1518115a"
import script from "./PreferredSkills.vue?vue&type=script&lang=js"
export * from "./PreferredSkills.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__